import React, { useEffect, useState } from 'react';
import SupplierBreadcrumb from './SupplierBreadcrumb';
import SupplierTabs from './SupplierTabs';
import { useParams } from 'react-router-dom'; // To extract ID from URL
import axios from 'axios';

function Supplier() {
  const { id } = useParams(); // assumes route like /supplier/:id
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSupplier = async () => {
      try {
        const res = await axios.get(` https://backend-zkgn.onrender.com/api/suppliers/${id}`);
        setSupplier(res.data);
      } catch (err) {
        setError('Failed to fetch supplier');
      } finally {
        setLoading(false);
      }
    };

    fetchSupplier();
  }, [id]);

  if (loading) return <div className="text-center py-4">Loading...</div>;
  if (error) return <div className="text-danger py-4 text-center">{error}</div>;

  return (
    <>
      <SupplierBreadcrumb />
      <SupplierTabs supplier={supplier} />
      {/* <SupplierAdvertise /> */}
    </>
  );
}

export default Supplier;
